import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import FilterIcon from "@mui/icons-material/Tune";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CircleLoader } from "react-spinners";
import {
  barClubDeleteRequest,
  barClubResetState,
  barClubViewAllRequest,
} from "../../../../redux/barclub/BarClubAction";
import { wholesalerViewAllRequest } from "../../../../redux/wholesaler/WholesalerAction";
import { getColumnWidth } from "../../../../style/datagridMQ";
import { filterStyles, styles } from "../../../components/LoginStyles";
import {
  ActiveValue,
  InactiveValue,
  StyledContainer,
} from "../../../components/style";
import CustomDataGrid from "../../../constant/commondatagrid";
import Pagination from "../../../constant/CommonPagenation";
import DeleteDialog from "../../../constant/commonDeleteDialogBox";
import LicenseDialog from "../../../constant/CommonViewDialogbox";
import CommonSnackbar from "../../../notification/Snackbar";
import { LicenseProofCell, BarImageCell } from "../../../constant/imageList";

const ActionMenu = ({ user, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    navigate(`/admin/bar/edit/${user.id}`);
  };

  const handleDelete = () => {
    onDelete(user.id);
    handleClose();
  };

  const handleParticularDetails = () => {
    navigate(`/admin/bar/view/${user.id}`, {
      state: {
        vendor: user,
      },
    });
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHorizIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleParticularDetails} sx={styles.viewDetail}>
          View Detail
        </MenuItem>
        <MenuItem onClick={handleEdit} sx={styles.action}>
          Edit
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={styles.action}>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

const BarClubSalesReport = () => {
  const [rows, setRows] = useState([]);
  const [selection, setSelection] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const [openLicenseDialog, setOpenLicenseDialog] = useState(false);
  const [selectedLicenseProof, setSelectedLicenseProof] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [emptyList, setEmptyList] = useState([]);
  //search
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(wholesalerViewAllRequest());
  }, [dispatch]);

  const barClubViewAllState = useSelector(
    (state) => state?.barClub?.viewAllBarClub || {}
  );
  const barClubList = barClubViewAllState?.data || [];
  const totalRecords = barClubViewAllState?.totalRecords || 0;
  const barClubPageSize = barClubViewAllState?.pageSize || 10;

  const barClubDeleteState = useSelector(
    (state) => state?.barClub?.deleteBarClub || {}
  );

  const columns = (handleDeleteRow) => [
    {
      field: "bar_image",
      headerName: "Bar/Club Images",
      width: getColumnWidth("column"),
      renderCell: (params) => <BarImageCell images={params.value} />,
    },
    {
      field: "govt_id_image",
      headerName: "License Proof",
      width: getColumnWidth("column"),
      renderCell: (params) =>
        params.value && params.value.length > 0 ? (
          <LicenseProofCell values={params.value} />
        ) : (
          <span>Proof not available</span>
          // <span style={{ color: "gray", fontStyle: "italic" }}>Proof not available</span>
        ),
    },
    {
      field: "reg_no",
      headerName: "Register No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Unknown",
    },
    {
      field: "wholesaler_name",
      headerName: "Wholesaler Name",
      width: getColumnWidth("column"),
      renderCell: (params) =>
        params.row.WholeSaler?.wholesaler_name || "Unknown",
    },
    {
      field: "name",
      headerName: "Bar Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Name Not Provided",
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "First Name Not Provided",
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Last Name Not Provided",
    },
    {
      field: "email",
      headerName: "Email",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Email Not Provided",
    },
    {
      field: "contact",
      headerName: "Phone No",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Phone Number Not Available",
    },
    {
      field: "address",
      headerName: "Address",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "No Address Provided",
    },
    {
      field: "google_map_location",
      headerName: "Google Map Location",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Location Not Provided",
    },
    {
      field: "longitude",
      headerName: "Longitude",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Longitude Not Provided",
    },
    {
      field: "latitude",
      headerName: "Latitude",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Latitude Not Provided",
    },
    {
      field: "shop_open_and_close_time",
      headerName: "Shop Open and Close time",
      width: getColumnWidth("column"),
      renderCell: (params) => params.value || "Not Specified",
    },
    {
      field: "status",
      headerName: "Status",
      width: getColumnWidth("column"),
      renderCell: (params) => {
        return params.value === 1 ? (
          <ActiveValue>Active</ActiveValue>
        ) : (
          <InactiveValue>Inactive</InactiveValue>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: getColumnWidth("action"),
      renderCell: (params) => (
        <ActionMenu user={params.row} onDelete={handleDeleteRow} />
      ),
    },
  ];

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     await dispatch(barClubViewAllRequest(currentPage));
  //     setLoading(false);
  //   };
  //   fetchData();
  // }, [dispatch, currentPage]);

  useEffect(() => {
    const page = currentPage || 1;
    const search = (searchTerm || "").trim();

    setLoading(true);
    const timer = setTimeout(async () => {
      await dispatch(
        barClubViewAllRequest({ pageNo: page, search_key: search })
      );
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [currentPage, searchTerm, dispatch]);

  useEffect(() => {
    if (barClubViewAllState?.success) {
      setRows(barClubList);
    } else {
      setRows(emptyList);
    }
  }, [barClubViewAllState, barClubList]);

  useEffect(() => {
    if (barClubDeleteState?.success) {
      const payload = {
        pageNo: currentPage || 1,
        search_key: searchTerm?.trim() || "",
        pagination_required: true,
      };
      dispatch(barClubViewAllRequest(payload));
      dispatch(barClubResetState());
    }
  }, [barClubDeleteState?.success]);

  const handleDeleteRow = (id) => {
    setUserToDelete(id);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    dispatch(barClubDeleteRequest(userToDelete));
    setUserToDelete(null);
    setOpenDialog(false);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterCondition = (condition) => {
    const sortedRows = [...rows];
    switch (condition) {
      case "Sort by Bar Name Asc":
        sortedRows.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      case "Sort by Bar Name Desc":
        sortedRows.sort((a, b) => b?.name?.localeCompare(a?.name));
        break;
      default:
        console.log(`Unknown filter condition: ${condition}`);
        break;
    }
    setRows(sortedRows);
    handleFilterClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <>
      <Grid container spacing={2} pl={6} pr={6}>
        <Grid item xs={12} sm={7} md={7} lg={9} xl={9}>
          <Box className="headingTable">
            <h1>Bar & Club Management</h1>
            <p>Here is the complete list of Bars/Clubs data</p>
          </Box>
        </Grid>
        <Grid item xs={12} sm={5} md={5} lg={3} xl={3}>
          <Box style={filterStyles.style}>
            <Button
              variant="contained"
              startIcon={<FilterIcon color="blue" />}
              endIcon={<ExpandMoreIcon />}
              onClick={handleFilterClick}
              sx={filterStyles.filterColor}
            >
              Filter
            </Button>
          </Box>
        </Grid>
      </Grid>
      <StyledContainer>
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterClose}
        >
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Asc")}
          >
            Bar Name A-Z
          </MenuItem>
          <MenuItem
            onClick={() => handleFilterCondition("Sort by Bar Name Desc")}
          >
            Bar Name Z-A
          </MenuItem>
        </Menu>
        {barClubViewAllState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1000}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={barClubViewAllState?.inProgress}
                size={50}
                color="#0458d3"
              />
            </Box>
          </Box>
        )}

        {barClubDeleteState?.inProgress && (
          <Box
            position="absolute"
            top={0}
            left={0}
            right={0}
            bottom={0}
            bgcolor="rgba(255, 255, 255, 0.5)"
            zIndex={1001}
          >
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <CircleLoader
                loading={barClubDeleteState?.inProgress}
                size={50}
                color="#d32f2f"
              />
            </Box>
          </Box>
        )}

        <Paper>
          {/*search*/}
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <input
              type="text"
              placeholder="Search by bar/wholesaler name or reg no..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "300px",
              }}
            />
          </Box>
          <Box>
            {!barClubViewAllState?.inProgress && (
              <Box>
                <CustomDataGrid
                  rows={rows}
                  columns={columns(handleDeleteRow)}
                  pageSize={barClubPageSize}
                  pagination={true}
                  onSelectionModelChange={(newSelection) => {
                    setSelection(newSelection);
                  }}
                  rowHeight={100}
                />
                {selection.length > 0 && (
                  <div>
                    <h2>Selected Rows:</h2>
                    {selection.map((id) => (
                      <div key={id}>
                        {rows.find((row) => row.id === id).CustomerName}
                      </div>
                    ))}
                  </div>
                )}
              </Box>
            )}
          </Box>
        </Paper>

        <Box mt={2}>
          <Grid>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRecords={totalRecords}
              pageSize={barClubPageSize}
            />
          </Grid>
        </Box>
        <DeleteDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          onConfirm={confirmDelete}
        />
        <LicenseDialog
          open={openLicenseDialog}
          onClose={() => setOpenLicenseDialog(false)}
          licenseProof={selectedLicenseProof}
        />
        <CommonSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
      </StyledContainer>
    </>
  );
};

export default BarClubSalesReport;
